document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".accordion-section");

  accordions.forEach((section) => {
    const content = section.querySelector(".accordion-content");

    section.addEventListener("click", function (event) {
      if (content.contains(event.target) && event.target.tagName === "A") {
        return;
      }

      const expanded = section.getAttribute("aria-expanded") === "true";
      accordions.forEach((s) => s.setAttribute("aria-expanded", "false"));
      section.setAttribute("aria-expanded", expanded ? "false" : "true");
    });

    section.style.cursor = "pointer";
  });
});
